import { useEffect, useRef } from "react";

const ENABLE_SCROLL = false;
export function useScrollIntoView<T extends Element>() {
  const ref = useRef<T>(null);

  // TODO doesn't work with Safari > 15.4
  useEffect(() => {
    ENABLE_SCROLL &&
      ref.current?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }, []);

  return ref;
}
